<!-- 课程类型 -->
<template>
    <div style="width: 100%; height: 100%;">
        <iframe id="iframeContainer" name="iframeContainer" ref="iframeContaineriframe" :src="env + `#/${url}?` + randomnumber" @load="init()"></iframe>
    </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick, watch, onUnmounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'
import tool from '@/utils/tool'
/**
 *
 * @param {Object} url  需要链接的页面地址
 * @param {Array} data  需要传递的参数
 */
const props = defineProps({
    url: {
        type: String,
        default: '',
    },
    data: {
        type: Object,
    },
})
// console.log(props, '看看是否获取到传递的数据')
const router = useRouter()
/** iframe必须 */
const env = import.meta.env.VUE_APP_API_IFRAME_BASEURL
const TOKEN = ref(tool.cookie.get('TOKEN'))
var randomnumber = Math.floor(Math.random() * 100000)
const iframeContaineriframe = ref(null)
const init = async () => {
    const arr = {
        TOKEN: TOKEN.value,
        data: props.data,
    }
    const jsonMessage = JSON.stringify(arr)
    if (iframeContaineriframe.value) {
        await iframeContaineriframe.value?.contentWindow?.postMessage(jsonMessage, `${env}`)
    }
}
const isToken = ref(true)
window.addEventListener(
    'message',
    function (e) {
        if (e.data === 'tokenError') {
            if (tool.data.get('isToken')) {
            } else {
                tool.data.set('isToken', isToken.value)
                ElMessageBox.confirm('当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。', '无权限访问', {
                    type: 'error',
                    closeOnClickModal: false,
                    center: true,
                    confirmButtonText: '重新登录',
                })
                    .then(() => {
                        router.replace({ path: '/login' })
                    })
                    .catch(() => {})
            }
        }
    },
    false
)
</script>
<style lang="scss" scoped>
#iframeContainer {
    width: 100%;
    height: 100%;
}
</style>
